<template>
    <div>
        <notifications position="top center" group="info" />

        <div>Titre</div>
        <b-input v-model="title"></b-input>

        <div>Destinataire</div>
        <vue-tags-input
            :autocomplete-min-length="0"
            placeholder="Ajouter un destinataire"
            v-model="tag"
            :tags="tags"
            :autocomplete-items="filteredItems"
            @tags-changed="newTags => tags = newTags"
            style="max-width: 100%"
        />

        <br />
        <vue-editor :editorToolbar="toolbar" v-model="content"></vue-editor>

        <br />
        <b-button @click="send">Envoyer</b-button>

    </div>

</template>

<script>
    import store from "../store.js";
    import messages_services from "../services/messages.js";

    import { VueEditor } from "vue2-editor";
	import VueTagsInput from "@johmun/vue-tags-input";

	export default {
        name: "message_send",
        components: {
            VueEditor,
            VueTagsInput
        },
        computed: {
            filteredItems() {
                return this.client_users.filter(i => {
                    return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
                });
            },
        },
		data: function () {
			return {
                toolbar: [
                    [{ 'header': [false, 1, 2, 3, 4, 5, 6, ] }],
                    [{ 'size': ['small', false, 'large', 'huge'] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
                    ['blockquote', 'code-block'],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
                    [{ 'color': [] }, { 'background': [] }],
                    ['link', 'video', 'formula'],
                    ['clean']
                ],
                content: "",
                title: "",
                dest: "",
                tag: '',
                tags: [],
                client_users: []
			};
		},
		methods: {
            async send()
            {
                if (!this.title || !this.content)
                {
                    this.$notify({
						group: "info",
						title: "Il n'y a pas de titre et/ou de texte. Le message n'a pas été envoyé",
						type: "error",
					});
                }
                else
                {
                    this.dest = "";

                    for (var i = 0; i < this.tags.length; i++)
                    {
                        if (this.dest)
                            this.dest += ";";
                        this.dest += this.tags[i].text.replace(/.*</, "").replace(/>.*/, "");
                    }

                    var resp = await messages_services.post(this.title, this.dest, this.content);

                    var error_dest = "";

                    for (var i = 0; i < resp.data.error_dest.length; i++)
                    {
                        if (error_dest)
                            error_dest += ", ";
                        error_dest += resp.data.error_dest[i].dest;
                    }

                    if (error_dest)
                    {
                        this.$notify({
                            group: "info",
                            title: "Le message n'a pas pu être envoyé à " + error_dest,
                            type: "error",
                        });
                    }
                    else
                    {
                        this.$notify({
                            group: "info",
                            title: "Message envoyé",
                            type: "success",
                        });
                    }

                    this.content = "";
                    this.title = "";
                    this.dest = "";
                    this.tag = '';
                    this.tags = [];
                }
            }
		},
		mounted: async function () {
            
            if (store.state.user.rules && !store.state.user.rules.messages) {
                this.$router.push({ name: "profile" });
            }

            this.client_users = await messages_services.getUsers();
		},
	};
</script>
